import React, { useEffect } from "react";
import "./styles.scss";
import InputLabel from "@mui/material/InputLabel/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select/Select";
import TextField from "@mui/material/TextField";
import { SelectorInput } from "../../../utils/styles";
import { filterByValue } from "../../../utils/utils";

function FilterItem(props) {
  const {
    selectorItems,
    changeSelectorValue,
    filterBy,
    filterProps = [],
    customLabel,
    showLabel = true,
    multiple = false,
  } = props;
  const [value, setValue] = React.useState(multiple ? [] : "");

  const handleSelectorValueChange = React.useCallback(
    (event) => {
      const newValue = multiple
        ? Array.isArray(event.target.value)
          ? event.target.value
          : [event.target.value]
        : event.target.value;

      if (selectorItems[0]?.type === "number") {
        if (newValue === "" || Number(newValue) >= 0) {
          setValue(newValue);
          changeSelectorValue(newValue, filterBy);
        }
      } else {
        setValue(newValue);
        changeSelectorValue(newValue, filterBy);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [changeSelectorValue, filterBy, selectorItems]
  );

  useEffect(() => {
    if (!!filterProps && filterProps.length) {
      filterProps.forEach((filter) => {
        if (filter.filterBy === filterBy) {
          if (multiple) {
            const incoming = Array.isArray(filter.filter)
              ? filter.filter
              : [filter.filter].filter(Boolean);
            setValue(incoming);
          } else {
            setValue(filter.filter);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterProps, filterBy, selectorItems]);

  if (selectorItems && selectorItems[0]?.type === "date") {
    return (
      <div className={"filterItemContainer"}>
        <InputLabel className={"filterInputLabel"}>
          {filterByValue(filterBy)
            .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
            .toLowerCase()
            .replace(/_/g, " ")}
        </InputLabel>
        <TextField
          type="datetime-local"
          value={value}
          onChange={handleSelectorValueChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          className={"filterSelector"}
          sx={{ mr: "10%" }}
        />
      </div>
    );
  }

  if (selectorItems && selectorItems[0]?.type === "number") {
    return (
      <div className={"filterItemContainer"}>
        <InputLabel className={"filterInputLabel"}>
          {customLabel ||
            filterByValue(filterBy)
              .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
              .toLowerCase()
              .replace(/_/g, " ")}
        </InputLabel>
        <TextField
          type="number"
          value={value}
          onChange={handleSelectorValueChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          className={"filterSelector"}
          label={selectorItems[0]?.label || undefined}
          sx={{ mr: "10%" }}
          inputProps={{ min: 0 }}
        />
      </div>
    );
  }

  return (
    <div className={"filterItemContainer"}>
      {showLabel && (
        <InputLabel className={"filterInputLabel"}>
          {filterByValue(filterBy)
            .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
            .toLowerCase()
            .replace(/_/g, " ")}
        </InputLabel>
      )}
      <Select
        sx={{
          "& .MuiInputBase-input": {
            boxShadow: "none",
            padding: "8px 20px 8px 10px",
            fontSize: 16,
            borderColor: "rgba(0, 0, 0, 0.23)",
            backgroundColor: "#fff",
          },
        }}
        className={"filterSelector"}
        onChange={handleSelectorValueChange}
        input={<SelectorInput />}
        value={value}
        multiple={multiple}
        renderValue={
          multiple
            ? (selected) =>
                (Array.isArray(selected) ? selected : [])
                  .map((sel) => {
                    const item = selectorItems.find((i) => i.name === sel);
                    return (item?.label ?? item?.name ?? sel).replace(
                      /_/g,
                      " "
                    );
                  })
                  .join(", ")
            : undefined
        }
      >
        <MenuItem value={""}>
          <em>None</em>
        </MenuItem>
        {selectorItems?.map((item) => (
          <MenuItem key={item.id} value={item.name}>
            {(item.label ?? item.name).replace(/_/g, " ")}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

export default FilterItem;
